import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';

import ProfileImg from './profile.png';
import config from '../../api/config.json';
import api from '../../api';
import { getAllUsers } from '../../redux/actions/users';
import { getAllDevices } from '../../redux/actions/devices';
import AlertMsg from '../AlertMsg';

const ModalLoginBySupervisor = props => {
  const sortable = (a, b) => {
    const n1 = Number(a.label.split(' | ')[0], 10);
    const n2 = Number(b.label.split(' | ')[0], 10);
    return n1 < n2 ? -1 : n1 > n2 ? 1 : 0;
  };

  const customThemes = theme => ({
    ...theme,
    colors: { ...theme.colors, primary: '#80bdff' }
  });

  const customFilter = (option, searchText) =>
    !!option.data.label.toLowerCase().includes(searchText.toLowerCase());

  const customStyle = {
    control: provided => ({
      ...provided,
      borderRadius: '0px',
      '&:hover': {
        color: '#495057',
        backgroundColor: '#fff',
        borderColor: '#80bdff',
        outline: 0,
        boxShadow: '0 0 0 .2rem rgba(0,123,255,.25)'
      }
    }),
    menu: provided => ({ ...provided, marginTop: '1px' }),
    downchevron: provided => ({ ...provided, borderRadius: '100px' })
  };
  const INITIAL_VALUES = {
    extension: '',
    idExtension: '',
    idUser: ''
  };
  const dispatch = useDispatch();
  const { modalShowLogin, setModalShowLogin } = props;
  const devices = useSelector(state => state.devices.data);
  const users = useSelector(state => state.users.data);
  const [firstOption] = useState({ value: '', label: '-- Selecione --' });
  const [optionsExtensions, setOptionsExtensions] = useState([
    { ...firstOption }
  ]);
  const [optionsUsers, setOptionsUsers] = useState([{ ...firstOption }]);
  const [data, setData] = useState({ INITIAL_VALUES });
  const [isFetching, setIsFetching] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorStatusCode, setErrorStatusCode] = useState(0);

  const handleClickLoginRamal = async () => {
    try {
      setIsFetching(true);
      await api().post('/api/devices/login_extension_by_supervisor', data);
      setIsSuccess(true);
      const options = optionsExtensions.filter(
        opt => opt.value !== data.idExtension
      );
      setOptionsExtensions([...options]);
      setData({ ...INITIAL_VALUES });
    } catch (err) {
      console.error(err);
      setIsError(true);
      setErrorStatusCode(err.response ? err.response.status : 0);
      if (err.response && err.response.status !== 403) {
        dispatch(getAllDevices());
      }
    } finally {
      setTimeout(() => {
        setIsFetching(false);
        setIsSuccess(false);
        setIsError(false);
        setErrorStatusCode(0);
      }, 1500);
    }
  };

  const showModal = () => {
    dispatch(getAllUsers());
    dispatch(getAllDevices());
    setData({ ...INITIAL_VALUES });
    setIsFetching(false);
    setErrorStatusCode(0);
  };

  useEffect(() => {
    if (devices.length && modalShowLogin) {
      const options = devices
        .filter(device => device.type === 'E' && !device.user)
        .map(device => ({
          value: device._id,
          number: device.number,
          label: `${device.number} | Dpto: ${device.department.name}`
        }))
        .sort(sortable);

      options.unshift(firstOption);
      setOptionsExtensions([...options]);
    }
  }, [devices, firstOption, modalShowLogin]);

  useEffect(() => {
    if (users.length && modalShowLogin) {
      const options = users
        .map(user => ({
          value: user._id,
          label: `${user.name} | Dpto: ${user.department.name}`
        }))
        .sort(sortable);

      options.unshift(firstOption);
      setOptionsUsers([...options]);
    }
  }, [users, firstOption, modalShowLogin]);

  return (
    <React.Fragment>
      <Modal
        show={modalShowLogin}
        onShow={showModal}
        onHide={() => setModalShowLogin(false)}
      >
        <Modal.Body>
          {!isSuccess && !isError && (
            <AlertMsg type="info" msg="Área de vínculo usuário no ramal" />
          )}
          {isSuccess && !isError && isFetching && (
            <AlertMsg type="success" msg="Usuário vinculado com sucesso" />
          )}
          {isError && errorStatusCode === 403 && isFetching && (
            <AlertMsg type="danger" msg="Licenciamento excedido" />
          )}
          {isError && errorStatusCode !== 403 && isFetching && (
            <AlertMsg type="danger" msg="Falha ao vincular usuário no ramal" />
          )}
          <div className="user-pic text-center mb-n4 mt-3">
            <img
              className="img-responsive shadow p-3 mb-5 bg-white rounded-circle"
              src={
                !data.idUser
                  ? ProfileImg
                  : `${config.protocol}://${config.ipServerGW}:${config.portServerGW}/api/users/image/${data.idUser}`
              }
              alt="Avatar"
            />
          </div>
          <h5>Nome Usuário</h5>
          <Select
            value={optionsUsers.find(opt => opt.value === data.idUser)}
            onChange={({ value }) => setData({ ...data, idUser: value })}
            isDisabled={isFetching}
            defaultValue={optionsUsers[0]}
            options={optionsUsers}
            isSearchable={true}
            theme={customThemes}
            styles={customStyle}
            filterOption={customFilter}
            noOptionsMessage={() => 'Nenhum registro encontrado'}
          />
          <h5 className="pt-3">Número Ramal</h5>
          <Select
            value={optionsExtensions.find(
              opt => opt.value === data.idExtension
            )}
            onChange={({ value, number }) =>
              setData({ ...data, idExtension: value, extension: number })
            }
            isDisabled={isFetching}
            defaultValue={optionsExtensions[0]}
            options={optionsExtensions}
            isSearchable={true}
            theme={customThemes}
            styles={customStyle}
            filterOption={customFilter}
            noOptionsMessage={() => 'Nenhum registro encontrado'}
          />
          <button
            type="button"
            className="mt-3 btn btn-info float-right"
            disabled={!data.idUser || !data.idExtension || isFetching}
            onClick={handleClickLoginRamal}
          >
            <i className="fa fa-link" />
            &nbsp;Logar No Ramal
          </button>
          <button
            type="button"
            className="mt-3 mr-2 btn btn-secondary float-right"
            onClick={() => setModalShowLogin(false)}
          >
            <i className="fas fa-times" />
            &nbsp;Fechar
          </button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

ModalLoginBySupervisor.propTypes = {
  modalShowLogin: PropTypes.bool,
  setModalShowLogin: PropTypes.func
};

export default ModalLoginBySupervisor;
